import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

export enum ForumListingSettingsDescriptionLimitIds {
    Small,
    Medium,
    Big,
    Unlimited,
}

export enum ForumListingSettingsDescriptionLimit {
    Small = 100,
    Medium = 300,
    Big = 500,
}

export const ForumListingSettingsDescriptionLimitOptions: INameIdObj[] = [
    {
        Id: ForumListingSettingsDescriptionLimitIds.Small,
        Name: 'settings.characters_limit_small',
    },
    {
        Id: ForumListingSettingsDescriptionLimitIds.Medium,
        Name: 'settings.characters_limit_medium',
    },
    {
        Id: ForumListingSettingsDescriptionLimitIds.Big,
        Name: 'settings.characters_limit_big',
    },
    {
        Id: ForumListingSettingsDescriptionLimitIds.Unlimited,
        Name: 'settings.unlimited',
    },
];
